import { eventImages } from "../assets";

export const EventsDetails = [
  {
    img: eventImages.TechVistaHackathon,
    name: "2nd Place at MetaSquid Hackathon, VSIT 2025",
  },
  {
    img: eventImages.TatvaHackathon,
    name: "1st Place at Tatva Hackathon, Chetna Clg 2024",
  },
  {
    img: eventImages.CNCFThaneJune,
    name: "CNCF June Meetup, 2025",
  },
  {
    img: eventImages.MongoDB,
    name: "MongoDB Mumbai 2024",
  },
  {
    img: eventImages.middleware,
    name: "Middleware Nov 2024",
  },
  {
    img: eventImages.BrowserStack,
    name: "BrowserStack Nov 2024",
  },
  {
    img: eventImages.BreachForceSep,
    name: "BreachForce Sep 2024",
  },
  {
    img: eventImages.CNCFThaneAug,
    name: "CNCF Thane Aug 2024",
  },
];
